<script setup lang="ts">
import { ref } from 'vue';

withDefaults(
  defineProps<{
    text: string;
    placement?: 'top' | 'bottom';
  }>(),
  {
    placement: 'top',
  }
);

const visible = ref(false);

function show() {
  visible.value = true;
}

function hide() {
  visible.value = false;
}
</script>

<template>
  <span
    class="mbw-tooltip"
    @mouseenter="show"
    @mouseleave="hide"
    @focusin="show"
    @focusout="hide"
  >
    <slot />
    <span
      v-if="visible && text"
      class="mbw-tooltip__bubble"
      :class="`mbw-tooltip__bubble--${placement}`"
      role="tooltip"
    >
      {{ text }}
    </span>
  </span>
</template>
